import { post2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import useLayoutData from "@/shared/hooks/useLayoutData";
import { errorToast, objectIsEmpty } from "@/shared/utils/helpers";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import {
  MenuTranslationResponse,
  toLanguageFields,
} from "./menuTranslationHelpers";

interface Props {
  category?: string;
  name: string;
}

// name: the name translated, description: a short description written from the name.
// Nothing is saved, the result fills the language fields of the form
const useMenuItemTranslatePost = (type: "name" | "description") => {
  const branch = useBranchId();
  const { franchiseLanguages } = useLayoutData();
  const fieldKeys = franchiseLanguages.map((language) => language.key);
  const endpoint = type === "name" ? "translate" : "description";

  const mutation = useMutation<Record<string, string>, AxiosError, Props>({
    mutationFn: ({ category, name }) =>
      post2(`internal/secure/pos/v1/menus/${endpoint}/${branch}`, {
        category,
        name,
      }).then((data: MenuTranslationResponse) =>
        toLanguageFields(data, fieldKeys)
      ),
    onSuccess: (data) => {
      objectIsEmpty(data) && errorToast();
    },
    onError: () => {
      errorToast();
    },
  });

  return mutation;
};

export default useMenuItemTranslatePost;
